import React from "react";
import { Link } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import "../css/main.scss";

function Main() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="prestige--v4 features--heading-small features--heading-uppercase template-index">
      <div className="PageContainer">
        <Header />
        <main id="main">
          {/* 1 */}
          <div
            id="shopify-section-template--17866866491476__hero_AApPVH"
            className="shopify-section shopify-section--hero"
          >
            <section
              id="section-template--17866866491476__hero_AApPVH"
              data-section-id="template--17866866491476__hero_AApPVH"
              data-section-type="slideshow"
            >
              <div className="Slideshow ">
                <div className="Slideshow__Carousel Carousel Carousel--insideDots flickity-enabled">
                  <div
                    className="flickity-viewport"
                    style={{ height: "295.612px" }}
                  >
                    <div className="flickity-slider" style={{ height: "100%" }}>
                      <div
                        id="Slideimage_CHjyHh"
                        className="Slideshow__Slide Carousel__Cell is-selected"
                        style={{
                          visibility: "inherit",
                          opacity: 1,
                          height: "100%",
                        }}
                        data-slide-index={0}
                      >
                        <Link onClick={toTop} to="/shop">
                          <div
                            className="Slideshow__ImageContainer  AspectRatio AspectRatio--withFallback hidden-phone"
                            style={{
                              paddingBottom: "19.66604823747681%",
                              backgroundImage: "url(/main/main1.gif)",
                            }}
                          >
                            <img
                              src="/main/main1.gif"
                              alt=""
                              width={1920}
                              height={378}
                              loading="eager"
                              className="Slideshow__Image"
                              data-optimux="1.2"
                              sizes="auto"
                              style={{ opacity: 1 }}
                            />
                          </div>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <span
                id="section-template--17866866491476__hero_AApPVH-end"
                className="Anchor"
              />
            </section>
            <style
              dangerouslySetInnerHTML={{
                __html:
                  "\n    #section-template--17866866491476__hero_AApPVH .Heading,\n    #section-template--17866866491476__hero_AApPVH .flickity-page-dots {\n      color: #ffffff;\n    }\n\n    #section-template--17866866491476__hero_AApPVH .Button {\n      color: #1c1b1b;\n      border-color: #ffffff;\n    }\n\n    #section-template--17866866491476__hero_AApPVH .Button::before {\n      background-color: #ffffff;\n    }\n\n    #section-template--17866866491476__hero_AApPVH .Underlined {\n      color: #ffffff;\n      border-color: #ffffff;\n    }\n  ",
              }}
            />
          </div>
          {/* 2 */}
          <div
            id="shopify-section-template--17866866491476__media_grid_gfHVid"
            className="shopify-section shopify-section__media-grid shopify-section--bordered"
          >
            <style
              dangerouslySetInnerHTML={{
                __html:
                  ".media-grid__items--template--17866866491476__media_grid_gfHVid {\n      display: grid;\n      grid-column-gap: var(--media-grid-col-gap, 5px);\n      grid-row-gap: var(--media-grid-row-gap, 6px);\n      grid-template-columns: repeat(var(--media-grid-cols, 2), 1fr);}\n\n    @media (min-width: 768px) {\n      .media-grid__items--template--17866866491476__media_grid_gfHVid {\n        --media-grid-col-gap: 7px;\n        --media-grid-row-gap: 7px;\n        --media-grid-cols: 4;\n      }\n    }\n\n    @media (min-width: 1140px) {\n      .media-grid__items--template--17866866491476__media_grid_gfHVid {\n        --media-grid-col-gap: 7px;\n        --media-grid-row-gap: 7px;\n        --media-grid-cols: 4;\n      }\n    }\n  ",
              }}
            />
            <section
              className="Section--spacingNone"
              id="section-template--17866866491476__media_grid_gfHVid"
              data-section-type="media-grid"
              data-section-id="template--17866866491476__media_grid_gfHVid"
            >
              <div
                className="media-grid__items media-grid__items--template--17866866491476__media_grid_gfHVid"
                style={{ paddingBottom: 6, paddingTop: 0 }}
              >
                <Link
                  onClick={toTop}
                  className="media-grid__item"
                  to="/shop"
                  style={{ minHeight: "100%", display: "block" }}
                >
                  <picture>
                    <img
                      src="/main/main2-1.jpg"
                      alt=""
                      width={500}
                      height={675}
                      loading="lazy"
                      aria-hidden="true"
                      role="presentation"
                      style={{ minHeight: "100%", objectFit: "cover" }}
                    />
                  </picture>
                </Link>
                <Link
                  onClick={toTop}
                  className="media-grid__item"
                  to="/shop"
                  style={{ minHeight: "100%", display: "block" }}
                >
                  <picture>
                    <img
                      src="/main/main2-2.jpg"
                      alt=""
                      width={500}
                      height={675}
                      loading="eager"
                      aria-hidden="true"
                      role="presentation"
                      style={{ minHeight: "100%", objectFit: "cover" }}
                    />
                  </picture>
                </Link>
                <Link
                  onClick={toTop}
                  className="media-grid__item"
                  to="/shop"
                  style={{ minHeight: "100%", display: "block" }}
                >
                  <picture>
                    <img
                      src="/main/main2-3.jpg"
                      alt=""
                      width={500}
                      height={675}
                      loading="lazy"
                      aria-hidden="true"
                      role="presentation"
                      style={{ minHeight: "100%", objectFit: "cover" }}
                    />
                  </picture>
                </Link>
                <Link
                  onClick={toTop}
                  className="media-grid__item"
                  to="/shop"
                  style={{ minHeight: "100%", display: "block" }}
                >
                  <picture>
                    <img
                      src="/main/main2-4.jpg"
                      alt=""
                      width={500}
                      height={675}
                      loading="lazy"
                      aria-hidden="true"
                      role="presentation"
                      style={{ minHeight: "100%", objectFit: "cover" }}
                    />
                  </picture>
                </Link>
              </div>
            </section>
          </div>
          {/* 3 */}
          <div
            id="shopify-section-template--17866866491476__media_grid_PqnzR9"
            className="shopify-section shopify-section__media-grid shopify-section--bordered"
          >
            <style
              dangerouslySetInnerHTML={{
                __html:
                  ".media-grid__items--template--17866866491476__media_grid_PqnzR9 {\n      display: grid;\n      grid-column-gap: var(--media-grid-col-gap, 5px);\n      grid-row-gap: var(--media-grid-row-gap, 6px);\n      grid-template-columns: repeat(var(--media-grid-cols, 3), 1fr);}\n\n    @media (min-width: 768px) {\n      .media-grid__items--template--17866866491476__media_grid_PqnzR9 {\n        --media-grid-col-gap: 7px;\n        --media-grid-row-gap: 7px;\n        --media-grid-cols: 5;\n      }\n    }\n\n    @media (min-width: 1140px) {\n      .media-grid__items--template--17866866491476__media_grid_PqnzR9 {\n        --media-grid-col-gap: 7px;\n        --media-grid-row-gap: 7px;\n        --media-grid-cols: 5;\n      }\n    }\n  ",
              }}
            />
            <section
              className="Section--spacingNone"
              id="section-template--17866866491476__media_grid_PqnzR9"
              data-section-type="media-grid"
              data-section-id="template--17866866491476__media_grid_PqnzR9"
            >
              <div
                className="media-grid__items media-grid__items--template--17866866491476__media_grid_PqnzR9"
                style={{ paddingBottom: 6, paddingTop: 6 }}
              >
                <Link
                  onClick={toTop}
                  className="media-grid__item"
                  to="/shop"
                  style={{ minHeight: "100%", display: "block" }}
                >
                  <picture>
                    <img
                      src="/main/main3-1.gif"
                      alt=""
                      width={500}
                      height={600}
                      loading="lazy"
                      aria-hidden="true"
                      role="presentation"
                      style={{ minHeight: "100%", objectFit: "cover" }}
                    />
                  </picture>
                </Link>
                <Link
                  onClick={toTop}
                  className="media-grid__item"
                  to="/shop"
                  style={{ minHeight: "100%", display: "block" }}
                >
                  <picture>
                    <img
                      src="/main/main3-2.jpg"
                      alt=""
                      width={500}
                      height={675}
                      loading="lazy"
                      aria-hidden="true"
                      role="presentation"
                      style={{ minHeight: "100%", objectFit: "cover" }}
                    />
                  </picture>
                </Link>
                <Link
                  onClick={toTop}
                  className="media-grid__item"
                  to="/shop"
                  style={{ minHeight: "100%", display: "block" }}
                >
                  <picture>
                    <img
                      src="/main/main3-3.jpg"
                      alt=""
                      width={500}
                      height={675}
                      loading="lazy"
                      aria-hidden="true"
                      role="presentation"
                      style={{ minHeight: "100%", objectFit: "cover" }}
                    />
                  </picture>
                </Link>
                <Link
                  onClick={toTop}
                  className="media-grid__item"
                  to="/shop"
                  style={{ minHeight: "100%", display: "block" }}
                >
                  <picture>
                    <img
                      src="/main/main3-4.jpg"
                      alt=""
                      width={500}
                      height={675}
                      loading="lazy"
                      aria-hidden="true"
                      role="presentation"
                      style={{ minHeight: "100%", objectFit: "cover" }}
                    />
                  </picture>
                </Link>
                <Link
                  onClick={toTop}
                  className="media-grid__item"
                  to="/shop"
                  style={{ minHeight: "100%", display: "block" }}
                >
                  <picture>
                    <img
                      src="/main/main3-5.jpg"
                      alt=""
                      width={500}
                      height={675}
                      loading="eager"
                      aria-hidden="true"
                      role="presentation"
                      style={{ minHeight: "100%", objectFit: "cover" }}
                    />
                  </picture>
                </Link>
              </div>
            </section>
          </div>
          {/* 4 */}
          <div
            id="shopify-section-template--17866866491476__hero_DxPnHy"
            className="shopify-section shopify-section--hero"
          >
            <section
              id="section-template--17866866491476__hero_DxPnHy"
              data-section-id="template--17866866491476__hero_DxPnHy"
              data-section-type="slideshow"
            >
              <div className="Slideshow ">
                <div className="Slideshow__Carousel Carousel Carousel--insideDots flickity-enabled">
                  <div
                    className="flickity-viewport"
                    style={{ height: "543.075px" }}
                  >
                    <div
                      className="flickity-slider"
                      style={{ left: 0, transform: "translateX(0%)" }}
                    >
                      <div
                        id="Slideimage_Qe4icm"
                        className="Slideshow__Slide Carousel__Cell is-selected"
                        style={{
                          visibility: "inherit",
                          position: "absolute",
                          left: "0%",
                          opacity: 1,
                        }}
                        data-slide-index={0}
                      >
                        <Link onClick={toTop} to="/shop">
                          <div
                            className="Slideshow__ImageContainer  AspectRatio AspectRatio--withFallback hidden-phone"
                            style={{
                              paddingBottom: "26.716141001855288%",
                              backgroundImage: "url(/main/main4.jpg)",
                            }}
                          >
                            <img
                              className="Slideshow__Image hide-no-js lazyautosizes Image--lazyLoaded"
                              data-optimumx="1.2"
                              data-widths="[400, 600, 800, 1000, 1200, 1400, 1600, 1800, 2000, 2200]"
                              data-sizes="auto"
                              alt=""
                              sizes="1503px"
                              style={{ opacity: 1 }}
                              src="/main/main4.jpg"
                            />
                          </div>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <span
                id="section-template--17866866491476__hero_DxPnHy-end"
                className="Anchor"
              />
            </section>
            <style
              dangerouslySetInnerHTML={{
                __html:
                  "\n    #section-template--17866866491476__hero_DxPnHy .Heading,\n    #section-template--17866866491476__hero_DxPnHy .flickity-page-dots {\n      color: #ffffff;\n    }\n\n    #section-template--17866866491476__hero_DxPnHy .Button {\n      color: #1c1b1b;\n      border-color: #ffffff;\n    }\n\n    #section-template--17866866491476__hero_DxPnHy .Button::before {\n      background-color: #ffffff;\n    }\n\n    #section-template--17866866491476__hero_DxPnHy .Underlined {\n      color: #ffffff;\n      border-color: #ffffff;\n    }\n  ",
              }}
            />
          </div>
          {/* 5 */}
          <div
            id="shopify-section-template--17866866491476__hero_DxPnHy"
            className="shopify-section shopify-section--hero"
            style={{ margin: "60px 0" }}
          >
            <section
              id="section-template--17866866491476__hero_DxPnHy"
              data-section-id="template--17866866491476__hero_DxPnHy"
              data-section-type="slideshow"
            >
              <div className="Slideshow ">
                <div className="Slideshow__Carousel Carousel Carousel--insideDots flickity-enabled">
                  <div
                    className="flickity-viewport"
                    style={{ height: "543.075px" }}
                  >
                    <div
                      className="flickity-slider"
                      style={{ left: 0, transform: "translateX(0%)" }}
                    >
                      <div
                        id="Slideimage_Qe4icm"
                        className="Slideshow__Slide Carousel__Cell is-selected"
                        style={{
                          visibility: "inherit",
                          position: "absolute",
                          left: "0%",
                          opacity: 1,
                        }}
                        data-slide-index={0}
                      >
                        <Link onClick={toTop} to="/shop">
                          <div
                            className="Slideshow__ImageContainer  AspectRatio AspectRatio--withFallback hidden-phone"
                            style={{
                              paddingBottom: "26.716141001855288%",
                              backgroundImage: "url(/main/main5.jpg)",
                            }}
                          >
                            <img
                              className="Slideshow__Image hide-no-js lazyautosizes Image--lazyLoaded"
                              data-optimumx="1.2"
                              data-widths="[400, 600, 800, 1000, 1200, 1400, 1600, 1800, 2000, 2200]"
                              data-sizes="auto"
                              alt=""
                              sizes="1503px"
                              style={{ opacity: 1 }}
                              src="/main/main5.jpg"
                            />
                          </div>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <span
                id="section-template--17866866491476__hero_DxPnHy-end"
                className="Anchor"
              />
            </section>
            <style
              dangerouslySetInnerHTML={{
                __html:
                  "\n    #section-template--17866866491476__hero_DxPnHy .Heading,\n    #section-template--17866866491476__hero_DxPnHy .flickity-page-dots {\n      color: #ffffff;\n    }\n\n    #section-template--17866866491476__hero_DxPnHy .Button {\n      color: #1c1b1b;\n      border-color: #ffffff;\n    }\n\n    #section-template--17866866491476__hero_DxPnHy .Button::before {\n      background-color: #ffffff;\n    }\n\n    #section-template--17866866491476__hero_DxPnHy .Underlined {\n      color: #ffffff;\n      border-color: #ffffff;\n    }\n  ",
              }}
            />
          </div>
          {/* 6 */}
          <div
            id="shopify-section-template--17866866491476__hero_DxPnHy"
            className="shopify-section shopify-section--hero"
            style={{ marginBottom: "60px" }}
          >
            <section
              id="section-template--17866866491476__hero_DxPnHy"
              data-section-id="template--17866866491476__hero_DxPnHy"
              data-section-type="slideshow"
            >
              <div className="Slideshow ">
                <div className="Slideshow__Carousel Carousel Carousel--insideDots flickity-enabled">
                  <div
                    className="flickity-viewport"
                    style={{ height: "543.075px" }}
                  >
                    <div
                      className="flickity-slider"
                      style={{ left: 0, transform: "translateX(0%)" }}
                    >
                      <div
                        id="Slideimage_Qe4icm"
                        className="Slideshow__Slide Carousel__Cell is-selected"
                        style={{
                          visibility: "inherit",
                          position: "absolute",
                          left: "0%",
                          opacity: 1,
                        }}
                        data-slide-index={0}
                      >
                        <Link onClick={toTop} to="/shop">
                          <div
                            className="Slideshow__ImageContainer  AspectRatio AspectRatio--withFallback hidden-phone"
                            style={{
                              paddingBottom: "26.716141001855288%",
                              backgroundImage: "url(/main/main6.jpg)",
                            }}
                          >
                            <img
                              className="Slideshow__Image hide-no-js lazyautosizes Image--lazyLoaded"
                              data-optimumx="1.2"
                              data-widths="[400, 600, 800, 1000, 1200, 1400, 1600, 1800, 2000, 2200]"
                              data-sizes="auto"
                              alt=""
                              sizes="1503px"
                              style={{ opacity: 1 }}
                              src="/main/main6.jpg"
                            />
                          </div>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <span
                id="section-template--17866866491476__hero_DxPnHy-end"
                className="Anchor"
              />
            </section>
            <style
              dangerouslySetInnerHTML={{
                __html:
                  "\n    #section-template--17866866491476__hero_DxPnHy .Heading,\n    #section-template--17866866491476__hero_DxPnHy .flickity-page-dots {\n      color: #ffffff;\n    }\n\n    #section-template--17866866491476__hero_DxPnHy .Button {\n      color: #1c1b1b;\n      border-color: #ffffff;\n    }\n\n    #section-template--17866866491476__hero_DxPnHy .Button::before {\n      background-color: #ffffff;\n    }\n\n    #section-template--17866866491476__hero_DxPnHy .Underlined {\n      color: #ffffff;\n      border-color: #ffffff;\n    }\n  ",
              }}
            />
          </div>
          {/* 7 */}
          <div
            id="shopify-section-template--17866866491476__hero_DxPnHy"
            className="shopify-section shopify-section--hero"
            style={{ marginBottom: "60px" }}
          >
            <section
              id="section-template--17866866491476__hero_DxPnHy"
              data-section-id="template--17866866491476__hero_DxPnHy"
              data-section-type="slideshow"
            >
              <div className="Slideshow ">
                <div className="Slideshow__Carousel Carousel Carousel--insideDots flickity-enabled">
                  <div
                    className="flickity-viewport"
                    style={{ height: "543.075px" }}
                  >
                    <div
                      className="flickity-slider"
                      style={{ left: 0, transform: "translateX(0%)" }}
                    >
                      <div
                        id="Slideimage_Qe4icm"
                        className="Slideshow__Slide Carousel__Cell is-selected"
                        style={{
                          visibility: "inherit",
                          position: "absolute",
                          left: "0%",
                          opacity: 1,
                        }}
                        data-slide-index={0}
                      >
                        <Link onClick={toTop} to="/shop">
                          <div
                            className="Slideshow__ImageContainer  AspectRatio AspectRatio--withFallback hidden-phone"
                            style={{
                              paddingBottom: "26.716141001855288%",
                              backgroundImage: "url(/main/main7.jpg)",
                            }}
                          >
                            <img
                              className="Slideshow__Image hide-no-js lazyautosizes Image--lazyLoaded"
                              data-optimumx="1.2"
                              data-widths="[400, 600, 800, 1000, 1200, 1400, 1600, 1800, 2000, 2200]"
                              data-sizes="auto"
                              alt=""
                              sizes="1503px"
                              style={{ opacity: 1 }}
                              src="/main/main7.jpg"
                            />
                          </div>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <span
                id="section-template--17866866491476__hero_DxPnHy-end"
                className="Anchor"
              />
            </section>
            <style
              dangerouslySetInnerHTML={{
                __html:
                  "\n    #section-template--17866866491476__hero_DxPnHy .Heading,\n    #section-template--17866866491476__hero_DxPnHy .flickity-page-dots {\n      color: #ffffff;\n    }\n\n    #section-template--17866866491476__hero_DxPnHy .Button {\n      color: #1c1b1b;\n      border-color: #ffffff;\n    }\n\n    #section-template--17866866491476__hero_DxPnHy .Button::before {\n      background-color: #ffffff;\n    }\n\n    #section-template--17866866491476__hero_DxPnHy .Underlined {\n      color: #ffffff;\n      border-color: #ffffff;\n    }\n  ",
              }}
            />
          </div>
          {/* 8 */}
          <div
            id="shopify-section-template--17866866491476__hero_DxPnHy"
            className="shopify-section shopify-section--hero"
            style={{ marginBottom: "60px" }}
          >
            <section
              id="section-template--17866866491476__hero_DxPnHy"
              data-section-id="template--17866866491476__hero_DxPnHy"
              data-section-type="slideshow"
            >
              <div className="Slideshow ">
                <div className="Slideshow__Carousel Carousel Carousel--insideDots flickity-enabled">
                  <div
                    className="flickity-viewport"
                    style={{ height: "543.075px" }}
                  >
                    <div
                      className="flickity-slider"
                      style={{ left: 0, transform: "translateX(0%)" }}
                    >
                      <div
                        id="Slideimage_Qe4icm"
                        className="Slideshow__Slide Carousel__Cell is-selected"
                        style={{
                          visibility: "inherit",
                          position: "absolute",
                          left: "0%",
                          opacity: 1,
                        }}
                        data-slide-index={0}
                      >
                        <Link onClick={toTop} to="/shop">
                          <div
                            className="Slideshow__ImageContainer  AspectRatio AspectRatio--withFallback hidden-phone"
                            style={{
                              paddingBottom: "26.716141001855288%",
                              backgroundImage: "url(/main/main8.jpg)",
                            }}
                          >
                            <img
                              className="Slideshow__Image hide-no-js lazyautosizes Image--lazyLoaded"
                              data-optimumx="1.2"
                              data-widths="[400, 600, 800, 1000, 1200, 1400, 1600, 1800, 2000, 2200]"
                              data-sizes="auto"
                              alt=""
                              sizes="1503px"
                              style={{ opacity: 1 }}
                              src="/main/main8.jpg"
                            />
                          </div>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <span
                id="section-template--17866866491476__hero_DxPnHy-end"
                className="Anchor"
              />
            </section>
            <style
              dangerouslySetInnerHTML={{
                __html:
                  "\n    #section-template--17866866491476__hero_DxPnHy .Heading,\n    #section-template--17866866491476__hero_DxPnHy .flickity-page-dots {\n      color: #ffffff;\n    }\n\n    #section-template--17866866491476__hero_DxPnHy .Button {\n      color: #1c1b1b;\n      border-color: #ffffff;\n    }\n\n    #section-template--17866866491476__hero_DxPnHy .Button::before {\n      background-color: #ffffff;\n    }\n\n    #section-template--17866866491476__hero_DxPnHy .Underlined {\n      color: #ffffff;\n      border-color: #ffffff;\n    }\n  ",
              }}
            />
          </div>
          {/* 9 */}
          <div
            id="shopify-section-template--17866866491476__hero_DxPnHy"
            className="shopify-section shopify-section--hero"
            style={{ marginBottom: "60px" }}
          >
            <section
              id="section-template--17866866491476__hero_DxPnHy"
              data-section-id="template--17866866491476__hero_DxPnHy"
              data-section-type="slideshow"
            >
              <div className="Slideshow ">
                <div className="Slideshow__Carousel Carousel Carousel--insideDots flickity-enabled">
                  <div
                    className="flickity-viewport"
                    style={{ height: "543.075px" }}
                  >
                    <div
                      className="flickity-slider"
                      style={{ left: 0, transform: "translateX(0%)" }}
                    >
                      <div
                        id="Slideimage_Qe4icm"
                        className="Slideshow__Slide Carousel__Cell is-selected"
                        style={{
                          visibility: "inherit",
                          position: "absolute",
                          left: "0%",
                          opacity: 1,
                        }}
                        data-slide-index={0}
                      >
                        <Link onClick={toTop} to="/shop">
                          <div
                            className="Slideshow__ImageContainer  AspectRatio AspectRatio--withFallback hidden-phone"
                            style={{
                              paddingBottom: "26.716141001855288%",
                              backgroundImage: "url(/main/main9.jpg)",
                            }}
                          >
                            <img
                              className="Slideshow__Image hide-no-js lazyautosizes Image--lazyLoaded"
                              data-optimumx="1.2"
                              data-widths="[400, 600, 800, 1000, 1200, 1400, 1600, 1800, 2000, 2200]"
                              data-sizes="auto"
                              alt=""
                              sizes="1503px"
                              style={{ opacity: 1 }}
                              src="/main/main9.jpg"
                            />
                          </div>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <span
                id="section-template--17866866491476__hero_DxPnHy-end"
                className="Anchor"
              />
            </section>
            <style
              dangerouslySetInnerHTML={{
                __html:
                  "\n    #section-template--17866866491476__hero_DxPnHy .Heading,\n    #section-template--17866866491476__hero_DxPnHy .flickity-page-dots {\n      color: #ffffff;\n    }\n\n    #section-template--17866866491476__hero_DxPnHy .Button {\n      color: #1c1b1b;\n      border-color: #ffffff;\n    }\n\n    #section-template--17866866491476__hero_DxPnHy .Button::before {\n      background-color: #ffffff;\n    }\n\n    #section-template--17866866491476__hero_DxPnHy .Underlined {\n      color: #ffffff;\n      border-color: #ffffff;\n    }\n  ",
              }}
            />
          </div>
          {/* 10 */}
          <div
            id="shopify-section-template--17866866491476__hero_pjkQe4"
            className="shopify-section shopify-section--hero"
          >
            <section
              id="section-template--17866866491476__hero_pjkQe4"
              data-section-id="template--17866866491476__hero_pjkQe4"
              data-section-type="slideshow"
            >
              <div className="Slideshow ">
                <div className="Slideshow__Carousel Carousel Carousel--insideDots flickity-enabled">
                  <div
                    className="flickity-viewport"
                    style={{ height: "82.025px" }}
                  >
                    <div
                      className="flickity-slider"
                      style={{ left: 0, transform: "translateX(0%)" }}
                    >
                      <div
                        id="Slideimage_UDTbqe"
                        className="Slideshow__Slide Carousel__Cell is-selected"
                        style={{
                          visibility: "inherit",
                          position: "absolute",
                          left: "0%",
                          opacity: 1,
                        }}
                        data-slide-index={0}
                      >
                        <div
                          className="Slideshow__ImageContainer  AspectRatio AspectRatio--withFallback hidden-phone"
                          style={{
                            paddingBottom: "4.0352504638218925%",
                            backgroundImage: "url(/main/main10.webp)",
                          }}
                        >
                          <img
                            className="Slideshow__Image hide-no-js lazyautosizes Image--lazyLoaded"
                            data-optimumx="1.2"
                            data-widths="[400, 600, 800, 1000, 1200, 1400, 1600, 1800, 2000, 2200]"
                            data-sizes="auto"
                            alt=""
                            sizes="1503px"
                            style={{ opacity: 1 }}
                            src="/main/main10.webp"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <span
                id="section-template--17866866491476__hero_pjkQe4-end"
                className="Anchor"
              />
            </section>
            <style
              dangerouslySetInnerHTML={{
                __html:
                  "\n    #section-template--17866866491476__hero_pjkQe4 .Heading,\n    #section-template--17866866491476__hero_pjkQe4 .flickity-page-dots {\n      color: #ffffff;\n    }\n\n    #section-template--17866866491476__hero_pjkQe4 .Button {\n      color: #363636;\n      border-color: #ffffff;\n    }\n\n    #section-template--17866866491476__hero_pjkQe4 .Button::before {\n      background-color: #ffffff;\n    }\n\n    #section-template--17866866491476__hero_pjkQe4 .Underlined {\n      color: #363636;\n      border-color: #363636;\n    }\n  ",
              }}
            />
          </div>
          {/* 11 */}
          <div
            id="shopify-section-template--17866866491476__media_grid_4KawNf"
            className="shopify-section shopify-section__media-grid shopify-section--bordered"
          >
            <style
              dangerouslySetInnerHTML={{
                __html:
                  ".media-grid__items--template--17866866491476__media_grid_4KawNf {\n      display: grid;\n      grid-column-gap: var(--media-grid-col-gap, 5px);\n      grid-row-gap: var(--media-grid-row-gap, 6px);\n      grid-template-columns: repeat(var(--media-grid-cols, 3), 1fr);}\n\n    @media (min-width: 768px) {\n      .media-grid__items--template--17866866491476__media_grid_4KawNf {\n        --media-grid-col-gap: 7px;\n        --media-grid-row-gap: 7px;\n        --media-grid-cols: 3;\n      }\n    }\n\n    @media (min-width: 1140px) {\n      .media-grid__items--template--17866866491476__media_grid_4KawNf {\n        --media-grid-col-gap: 7px;\n        --media-grid-row-gap: 7px;\n        --media-grid-cols: 6;\n      }\n    }\n  ",
              }}
            />
            <section
              className="Section--spacingNone"
              id="section-template--17866866491476__media_grid_4KawNf"
              data-section-type="media-grid"
              data-section-id="template--17866866491476__media_grid_4KawNf"
            >
              <div
                className="media-grid__items media-grid__items--template--17866866491476__media_grid_4KawNf"
                style={{ paddingBottom: 6, paddingTop: 0 }}
              >
                <Link
                  onClick={toTop}
                  className="media-grid__item"
                  to="/shop"
                  style={{ minHeight: "100%", display: "block" }}
                >
                  <picture>
                    <img
                      src="/main/main10-1.jpg"
                      alt=""
                      width={500}
                      height={500}
                      loading="lazy"
                      aria-hidden="true"
                      role="presentation"
                      style={{ minHeight: "100%", objectFit: "cover" }}
                    />
                  </picture>
                </Link>
                <Link
                  onClick={toTop}
                  className="media-grid__item"
                  to="/shop"
                  style={{ minHeight: "100%", display: "block" }}
                >
                  <picture>
                    <img
                      src="/main/main10-2.jpg"
                      alt=""
                      width={500}
                      height={500}
                      loading="eager"
                      aria-hidden="true"
                      role="presentation"
                      style={{ minHeight: "100%", objectFit: "cover" }}
                    />
                  </picture>
                </Link>
                <Link
                  onClick={toTop}
                  className="media-grid__item"
                  to="/shop"
                  style={{ minHeight: "100%", display: "block" }}
                >
                  <picture>
                    <img
                      src="/main/main10-3.jpg"
                      alt=""
                      width={500}
                      height={500}
                      loading="eager"
                      aria-hidden="true"
                      role="presentation"
                      style={{ minHeight: "100%", objectFit: "cover" }}
                    />
                  </picture>
                </Link>
                <Link
                  onClick={toTop}
                  className="media-grid__item"
                  to="/shop"
                  style={{ minHeight: "100%", display: "block" }}
                >
                  <picture>
                    <img
                      src="/main/main10-6.webp"
                      alt=""
                      width={500}
                      height={500}
                      loading="lazy"
                      aria-hidden="true"
                      role="presentation"
                      style={{ minHeight: "100%", objectFit: "cover" }}
                    />
                  </picture>
                </Link>
                <Link
                  onClick={toTop}
                  className="media-grid__item"
                  to="/shop"
                  style={{ minHeight: "100%", display: "block" }}
                >
                  <picture>
                    <img
                      src="/main/main10-4.jpg"
                      alt=""
                      width={500}
                      height={500}
                      loading="lazy"
                      aria-hidden="true"
                      role="presentation"
                      style={{ minHeight: "100%", objectFit: "cover" }}
                    />
                  </picture>
                </Link>
                <Link
                  onClick={toTop}
                  className="media-grid__item"
                  to="/shop"
                  style={{ minHeight: "100%", display: "block" }}
                >
                  <picture>
                    <img
                      src="/main/main10-5.jpg"
                      alt=""
                      width={500}
                      height={500}
                      loading="lazy"
                      aria-hidden="true"
                      role="presentation"
                      style={{ minHeight: "100%", objectFit: "cover" }}
                    />
                  </picture>
                </Link>
              </div>
            </section>
          </div>
        </main>
        <Footer />
      </div>
    </div>
  );
}

export default Main;
